import { render, staticRenderFns } from "./edit-table.vue?vue&type=template&id=2bc58ef4&scoped=true&"
import script from "./edit-table.vue?vue&type=script&lang=js&"
export * from "./edit-table.vue?vue&type=script&lang=js&"
import style0 from "./edit-table.vue?vue&type=style&index=0&id=2bc58ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc58ef4",
  null
  
)

component.options.__file = "edit-table.vue"
export default component.exports